// extracted by mini-css-extract-plugin
module.exports = {"cont":"Ads_cont__cjHBC","removeAds":"Ads_removeAds__mI9pr"};